import { useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { useAlumno } from "../../utils/useAlumno"
import Loading from "../../components/Loading/Loading"
import cloud from '../../assets/cloud.png'
import css from './Layout.module.css'

const Layout = ()=> {

  const navigate = useNavigate()
  const location = useLocation()

  const { token, isCompleted, isError, alumno } = useAlumno()  
  const path = location.pathname

  useEffect(()=> {
    if (token) return
    if (path === '/enlace-caducado') return
    if (path !== '/not-found') navigate('/not-found')
  }, [token, path, navigate])

  useEffect(()=> {
    if (!isError) return
    if (path === '/enlace-caducado') return
    if (path === '/contrato' || path === '/condiciones') return navigate('/enlace-caducado')
    if (path !== '/not-found') navigate('/not-found')
  }, [isError, path, navigate])

  useEffect(()=> {
    if (!alumno || !token) return
    if (!alumno.condicionesUrl) navigate(`/contrato?token=${token}`)
    else navigate(`/condiciones?token=${token}`)
  }, [alumno, token, navigate])

  return (
    <>
      <nav className={css.nav}>
        <img className={css.cloud} src={cloud} alt="mundoestudiante" />
        <h1 className={css.title}>Condiciones</h1>
      </nav>
      <div className={css.main}>
        {isCompleted ? <Outlet /> : <Loading />}
      </div>
    </>
  )
}
  export default Layout